export default __webpack_public_path__ + "static/media/curriculum-upload.8ae11add.svg";